import { Box, Collapse, IconButton, Stack } from '@mui/material'
import React from 'react'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { StyledSidebarSectionContainer } from '../../styles/SidebarStyles'
import SidebarDivider from './SidebarDivider'
import SidebarLink from './SidebarLink'
import { SidebarCollapsibleSectionProps } from '../../store/types/components/sidebar/sidebarTypes'

const SidebarCollapsibleSection: React.FC<SidebarCollapsibleSectionProps> = ({
  config,
  isSidebarExpanded,
  isCollapsing,
  linkRefs,
  onToggleSection,
  onCollapseStart,
  onCollapseComplete,
}) => {
  const Icon = config.icon
  const ariaLabel = config.open ? config.ariaLabelClose ?? config.label : config.ariaLabelOpen ?? config.label
  const justifyContent = isSidebarExpanded || !config.centerContentWhenCollapsed ? 'space-between' : 'center'
  const isToggleDisabled = !isSidebarExpanded && config.disableToggleWhenSidebarCollapsed
  const cursor = isToggleDisabled ? 'auto' : 'pointer'

  const handleClick = () => {
    if (isToggleDisabled) {
      return
    }
    onToggleSection(config.key)
  }

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          cursor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: justifyContent,
          width: '100%',
          pl: 1,
        }}
      >
        <Stack direction={'row'} sx={{ alignItems: 'center', gap: 1 }}>
          <Icon sx={{ width: 18 }} />
          <SidebarDivider open={isSidebarExpanded}>{config.label}</SidebarDivider>
        </Stack>
        {isSidebarExpanded && (
          <IconButton size="small" aria-label={ariaLabel}>
            {config.open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </Box>
      <Collapse
        in={config.open}
        timeout="auto"
        unmountOnExit
        onEnter={() => onCollapseStart(config.key, 'enter')}
        onExit={() => onCollapseStart(config.key, 'exit')}
        onEntered={onCollapseComplete}
        onExited={onCollapseComplete}
      >
        <StyledSidebarSectionContainer sx={{ alignItems: isSidebarExpanded ? 'left' : 'center' }}>
          {config.links.map(link => (
            <SidebarLink
              isCollapsing={isCollapsing}
              ref={el => {
                linkRefs.current[link.index] = el
              }}
              key={link.text}
              open={isSidebarExpanded}
              Icon={link.icon}
              text={link.text}
              route={link.route}
              index={link.index}
            />
          ))}
        </StyledSidebarSectionContainer>
      </Collapse>
    </>
  )
}

export default SidebarCollapsibleSection
